import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CONTACT_EMAIL, LEGAL_ENTITY, POLICY_VERSION } from '../legal.constants';

/** F-034 — static Privacy Policy. Content-only; edits ship via deploy. */
@Component({
  selector: 'app-privacy',
  imports: [RouterLink],
  templateUrl: './privacy.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Privacy {
  protected readonly contactEmail = CONTACT_EMAIL;
  protected readonly legalEntity = LEGAL_ENTITY;
  protected readonly lastUpdated = POLICY_VERSION;
}
